import Menu from "pages/menuMain/menu";
import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { RewardWordBook } from "services/Api/Module/Reward";
import helper from "services/helper";

const WordBookPrize = () => {
    const [rewardData, setRewardData] = useState({});
    const [isAccept, setIsAccept] = useState(false);
    const navigate = useNavigate();

    const stateProfile = useSelector((state) => state.profile.dataUser);
    const customerId = stateProfile.id;

    const stateCurrentPoint = useSelector((state) => state.currentPoint);
    const newCurrentPoint = stateCurrentPoint.currentPoint;

    let [searchParams, setSearchParams] = useSearchParams();
    const isLucky = searchParams.get("lucky") || false;

    // state page pdpd contions ต่างๆ
    const page = searchParams.get("page") ?? "";
    const isShowPage = !!page ? true : false;

    const currentPoint = newCurrentPoint ?? stateProfile.currentPoint ?? 0;

    const getRewardView = async () => {
        let _return = {
            status: false,
            result: {},
            rowCount: 0,
        };
        try {
            const { data } = await RewardWordBook({
                params: { lucky: isLucky }
            });
            if (data.resultCode === "20000") {
                const resData = data.resultData;
                const rowCount = data.rowCount;

                _return.status = true;
                _return.result = resData;
                _return.rowCount = rowCount;
            } else {
                navigate("/reward");
            }
        } catch (e) {
            console.log(e);
            return _return;
        }
        return _return;
    };

    const fetchRewardView = async () => {
        try {
            const resData = await getRewardView();
            setRewardData(resData.result);
        } catch (err) {
            console.log(err);
        }
    };

    const gotoConfrim = () => {
        if (isLucky) {
            navigate(`/word-book-prize-confirm?lucky=true`);
        } else {
            navigate(`/word-book-prize-confirm`);
        }
    };

    useEffect(() => {
        fetchRewardView();
    }, []);

    const contBTN0 = !isAccept; // กรณีไม่ checkboox
    const contBTN1 = !(currentPoint >= rewardData.pointToRedeem); // กรณี point ไม่พอ
    const contBTN2 = !(rewardData.total > rewardData.available); // กรณี ของ ไม่พอ
    const disabledBTN = contBTN0 || contBTN1 || contBTN2;
    // const disabledBTN = contBTN0 || contBTN1
    const styleShow = { display: isShowPage === false ? "block" : "none" };
    return (
        <div>
            {/* newCurrentPoint::{newCurrentPoint} */}
            <Helmet>
                <title>โคอะลา มาร์ช</title>
                <meta name="title" content="โคอะลา มาร์ช" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="โคอะลา มาร์ช" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>

            <div id="pageReward-Details" style={styleShow}>
                <main>
                    <div className="wrapContent">
                        <section id="pTitlePage">
                            <div className="bTitlePage">
                                <a
                                    className="btnIconBack"
                                    onClick={() => navigate("/word-book-main")}
                                ></a>
                                <h2>Wordbook</h2>
                            </div>
                        </section>
                        <section id="pContent">
                            <div className="bDetailsMain bCard">
                                <div className="bTitle">
                                    <h2>แลกของรางวัลพิเศษ</h2>
                                    <p>{isLucky ? 'คุณได้รับ Lucky Koala': 'คุณสะสมหัวใจครบ 10 ดวงแล้ว'}</p>
                                    <p>แลกของรางวัลพิเศษได้เลย</p>
                                </div>
                                <div className="bPointMain">
                                    <div className="bQuata">
                                        <div className="bRemaining">
                                            <p>
                                                แลกไปแล้ว{" "}
                                                <span>
                                                    {rewardData.used}/{rewardData.total}
                                                </span>
                                            </p>
                                            {/* <!-- คำนวณค่าออกมาเป็น % แล้วใส่ค่าที่ width: xx%; --> */}
                                            <div className="bBar">
                                                <span
                                                    style={{
                                                        width:
                                                            helper.FN.calPercen(
                                                                rewardData.used,
                                                                rewardData.total
                                                            ) + "%",
                                                    }}
                                                ></span>
                                            </div>
                                        </div>
                                        <div className="bDate">
                                            แลกได้ถึงวันที่:
                                            <span>
                                                {helper.TIME.toShortDateNormalTH(rewardData.toDate)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="bProductImg">
                                    <div className="bTitle">
                                        <h2>{rewardData.name}</h2>
                                    </div>
                                    <div className="bPic">
                                        <img
                                            src={
                                                rewardData.img
                                                    ? rewardData.img
                                                    : "https://dummyimage.com/200x200/fff/000"
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div className="bTag">จัดส่งฟรี!</div>
                                </div>
                                <div className="bCondition">
                                    <h3>เงื่อนไขการรับของรางวัล</h3>
                                    <div
                                        className="bText"
                                        dangerouslySetInnerHTML={{ __html: rewardData.conditions }}
                                    />
                                </div>
                            </div>
                        </section>
                        <section id="pBtnPage">
                            <div className="bBtn">
                                <div className="bForm">
                                </div>
                                <a
                                    onClick={() => gotoConfrim()}
                                    className="btn"
                                >
                                    แลกรางวัล
                                </a>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default WordBookPrize;
